
<app-breadcrumb [breadcrumbs] = "breadcrumbsData"></app-breadcrumb>
<router-outlet></router-outlet> 
